var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDownload = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.488 10.891a.724.724 0 0 0 1.024 0l2.73-2.73A.724.724 0 0 0 9.22 7.135L7.724 8.631V.724a.724.724 0 1 0-1.448 0v7.907L4.78 7.136A.724.724 0 0 0 3.757 8.16l2.73 2.731z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.276 6.276c-.4 0-.724.324-.724.724v5.552H1.448V7A.724.724 0 1 0 0 7v5.793C0 13.46.54 14 1.207 14h11.586C13.46 14 14 13.46 14 12.793V7c0-.4-.324-.724-.724-.724z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download.057f6f82.svg";
export { ForwardRef as ReactComponent };